require('./helpers/bundle-manifest').register(JSON.parse("{\"h00hi\":\"index.928f615f.js\",\"axpzy\":\"logo.637c9715.svg\",\"8Ky0g\":\"index.49b7a3f3.css\"}"));